import { Col, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';

import { platebniInstrukcePDFapi } from 'services/spravaEmitenta/amlzData';
import {
    ISubjPravo,
    amlzC2smsDetailGet,
    amlzC2smsDetailsend,
    biAmlzSmsRerouteApi,
    pdfBiSmsRerouteApi,
    pdfPodpisSmsApi
} from 'services/spravaEmitenta/zadostPravo';

import { ENotificationType } from 'enums/notificationType';

import AgendaAmlz from './formular/AgendaAmlzFormular';

interface IAgendaSMS {}

const AgendaSMS: React.FC<IAgendaSMS> = () => {
    const { zadostAgenda, language, NotificationComponent } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(true);
    const [showInstrukceAfterFinish, setshowInstrukceAfterFinish] = useState<boolean>(false);
    const [zadostData, setZadostData] = useState<ISubjPravo>();
    const [submitZadostData, setSubmitZadostData] = useState<ISubjPravo>();
    const [putResp, setPutResp] = useState<string>('');
    const [showSubmitSucc, setShowSubmitSucc] = useState<boolean>(false);
    const [isSubmittingManually, setIsSubmittingManually] = useState<boolean>(false);
    const [personDataFinish, setPersonDataFinish] = useState<boolean>(false);

    const apiListZadostSms = (idZadost: number | string, idOsoba: number | string, personObject: ISubjPravo) => {
        return {
            downloadSignature: () =>
                amlzC2smsDetailsend(idZadost, idOsoba, personObject, 'PUT').then(data => {
                    setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (data.stav === 'OK') {
                        pdfPodpisSmsApi(idZadost!, idOsoba);
                    }
                }),
            pdfBiReroute: () =>
                amlzC2smsDetailsend(idZadost, idOsoba, personObject, 'PUT').then(data => {
                    setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (data.stav === 'OK') {
                        return pdfBiSmsRerouteApi(idZadost, idOsoba, language);
                    }
                }),
            biReroute: () =>
                amlzC2smsDetailsend(idZadost, idOsoba, personObject, 'PUT').then(data => {
                    setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (data.stav === 'OK') {
                        return biAmlzSmsRerouteApi(idZadost, idOsoba, language);
                    }
                })
        };
    };

    useEffect(() => {
        setLoading(true);
        amlzC2smsDetailGet(zadostAgenda?.pristupc2?.id || 0, zadostAgenda?.pristupc2?.idosoby! || 0)
            .then(rezp => {
                setZadostData(rezp);
            })
            .finally(() => setLoading(false));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (submitZadostData) {
            if (!personDataFinish) {
                (setLoading(true),
                amlzC2smsDetailsend(
                    zadostAgenda?.pristupc2?.id!,
                    zadostAgenda?.pristupc2?.idosoby!,
                    submitZadostData,
                    'PUT'
                ).then(data => {
                    data && setPutResp(data.stav === 'OK' ? '' : data.stav);
                    if (isSubmittingManually && data.stav === 'OK') {
                        NotificationComponent({
                            type: ENotificationType.SUCCESS,
                            //   title: 'IDENTIFIKACE_OSOBY',
                            description: 'AMLZ_C2_PUT_SUCCESS'
                        });
                        setIsSubmittingManually(false);
                    }
                    amlzC2smsDetailGet(zadostAgenda?.pristupc2?.id!, zadostAgenda?.pristupc2?.idosoby!)
                        .then(rezp => {
                            setZadostData(rezp);
                            if (showInstrukceAfterFinish) {
                                setLoading(true);
                                platebniInstrukcePDFapi(
                                    zadostAgenda?.pristupc2?.id!,
                                    language,
                                    zadostAgenda?.pristupc2?.idosoby!
                                ).finally(() => setLoading(false));
                                setshowInstrukceAfterFinish(false);
                            }
                        })
                        .finally(() => setLoading(false));
                })).catch(() => setLoading(false));
            } else {
                amlzC2smsDetailsend(
                    zadostAgenda?.pristupc2?.id!,
                    zadostAgenda?.pristupc2?.idosoby!,
                    submitZadostData,
                    'POST'
                )
                    .then(() => {
                        /*  NotificationComponent({
                        type: ENotificationType.SUCCESS,
                        //   title: 'IDENTIFIKACE_OSOBY',
                        description: 'LEI_SPARAVA_ZADOST_SUCCESS_TITLE'
                    }); */
                        setShowSubmitSucc(true);
                    })
                    .finally(() => setLoading(false));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zadostAgenda?.pristupc2?.id, submitZadostData]);

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text="IDENTIFIKACE_OSOBY" />
            <Paragraph text={showSubmitSucc ? 'LEI_SPARAVA_ZADOST_SUCCESS_TITLE' : 'IDENTIFIKACE_OSOBY_ZADOST_TEXT'} />
            {zadostAgenda?.pristupc2?.id && zadostData && !showSubmitSucc && (
                <Row gutter={8}>
                    <Col span={24}>
                        <AgendaAmlz
                            setPdfCheckError={setPutResp}
                            pdfCheckError={putResp}
                            personData={zadostData}
                            setSubmitPersonData={setSubmitZadostData}
                            setPersonData={setZadostData}
                            idZadosti={zadostAgenda?.pristupc2?.id}
                            setshowInstrukceAfterFinish={setshowInstrukceAfterFinish}
                            setPersonDataFinish={setPersonDataFinish}
                            //    putResp={putResp}
                            idOsoby={zadostAgenda.pristupc2.idosoby}
                            mode={'smsLogin'}
                            apiList={apiListZadostSms}
                            setIsSubmittingManually={setIsSubmittingManually}
                        />
                    </Col>
                </Row>
            )}
        </LoadingWrapper>
    );
};

export default AgendaSMS;
